import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { usePatientContext } from "../../context/PatientContext";
import PatientListPane from "./PatientListPane";
import PatientOverviewPane from "./PatientOverviewPane";

/**
 * Patient Records module.
 *
 * Which view is showing and which Patient is open are component state; the URL
 * does not change (ADR-0002). Roster page and committed search live here too, so
 * returning from an Overview restores what the user left rather than resetting to
 * page one with a cleared search.
 */
export default function PatientRecords() {
  const { patient: activePatient, selectPatient } = usePatientContext();

  const [selectedPatient, setSelectedPatient] = useState(null);
  const [rosterPage, setRosterPage] = useState(0);
  const [rosterSearch, setRosterSearch] = useState("");

  const handleSelectPatient = (patient) => {
    setSelectedPatient(patient);
    // Make this the Active Patient so Appointments and Billing already know who
    // is being worked on.
    selectPatient(patient);
  };

  // Arriving with an Active Patient already picked (navbar search, or another
  // module) opens straight on that Patient's Overview instead of the roster.
  // Keyed on the id alone so pressing Back drops to the list and stays there —
  // only a *different* Active Patient re-opens an Overview.
  useEffect(() => {
    if (activePatient?.patient_id) {
      setSelectedPatient(activePatient);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePatient?.patient_id]);

  const handleSearchChange = (nextSearch) => {
    setRosterSearch(nextSearch);
    // A new search must land on page one, or the user stares at an empty page
    // carried over from the previous search.
    setRosterPage(0);
  };

  return (
    <Box sx={{ p: { xs: 1, md: 2 }, maxWidth: 1280, margin: "0 auto" }}>
      {selectedPatient ? (
        <PatientOverviewPane
          rosterPatient={selectedPatient}
          onBack={() => setSelectedPatient(null)}
        />
      ) : (
        <PatientListPane
          page={rosterPage}
          search={rosterSearch}
          onPageChange={setRosterPage}
          onSearchChange={handleSearchChange}
          onSelectPatient={handleSelectPatient}
        />
      )}
    </Box>
  );
}
